import { useNavigate } from 'react-router-dom'
import { Table } from 'reactstrap'
import useForm from '../../CustomHooks/FormHook'
import FormHeading from '../FormHeading'
import DateRangeInput from '../DateRangeInput'
import FormSubmitButton from '../FormSubmitButton'
import { enterKeyHandler } from '../../../utils'
import { initialFormValues, submitFormValues } from '../CustomUtils'
import '../Custom.css'

export default function ReopenedClaimsReportForm({ location }) {
  console.log('ReopenedClaimsReportForm rendered: ', location)

  let init = {
    dateReopenedFrom: '',
    dateReopenedTo: '',
  }

  const navigate = useNavigate()
  init = initialFormValues('ReopenedClaimsReportForm', navigate, init)
  const { inputs, handleInputChange, handleSubmit } = useForm(init, submitSearch, enterKeyHandler(submitSearch))

  async function submitSearch() {
    submitFormValues('ReopenedClaimsReportForm', navigate, inputs, 'reopened.reopened_claims_report')
  }

  return (
    <div className="custom-scroll">
      <form onSubmit={handleSubmit} style={{ maxWidth: '700px', margin: '20px auto' }}>
        <div>
          <Table bordered className="custom-table custom-form-table" style={{backgroundColor: 'white'}}>
            <FormHeading headingText='Reopened Claims Report' />
            <tbody>
              <DateRangeInput label='Date Re-opened' name='dateReopened' handleInputChange={handleInputChange} defaultValueFrom={inputs.dateReopenedFrom} defaultValueTo={inputs.dateReopenedTo} />
            </tbody>
          </Table>
        </div>
        <FormSubmitButton />
      </form>
    </div>
  )
}
